import React from "react";
import { Route, Routes } from "react-router-dom";
import AuthenticatedRoute from "./common/AuthenticatedRoute";
import UnauthenticatedRoute from "./common/UnauthenticatedRoute";

import MainMenu from "./menu/MainMenu";
import MainFreeform from "./freeform/MainFreeform";
import MainLogin from "./user/MainLogin";
import MainSignup from "./user/MainSignup";
import MainManageHabits from "./habits/MainManageHabits";
import MainCreateHabit from "./habits/MainCreateHabit";
import MainViewHabit from "./habits/MainViewHabit";
import MainEditHabit from "./habits/MainEditHabit";
import MainMultiDay from "./multiday/MainMultiDay";
import MainSingleSite from "./singlesite/MainSingleSite";

const NotFound = () => null;

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MainMenu />} />
      <Route
        path="/login"
        element={
          <UnauthenticatedRoute>
            <MainLogin />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <UnauthenticatedRoute>
            <MainSignup />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/daily/:habitId"
        element={
          <AuthenticatedRoute>
            <MainFreeform />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/multiday/:habitId"
        element={
          <AuthenticatedRoute>
            <MainMultiDay />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/site/:habitId"
        element={
          <AuthenticatedRoute>
            <MainSingleSite />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/manage"
        element={
          <AuthenticatedRoute>
            <MainManageHabits />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/create"
        element={
          <AuthenticatedRoute>
            <MainCreateHabit />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/view/:userId1/:userId2/:createdms"
        element={
          <AuthenticatedRoute>
            <MainViewHabit />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/edit/:userId1/:userId2/:createdms"
        element={
          <AuthenticatedRoute>
            <MainEditHabit />
          </AuthenticatedRoute>
        }
      />
      {/* Finally, catch all unmatched routes */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
